import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService, isSessionLoginRequired } from './auth.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { QR_LOGIN_ENABLED } from '../web-auth/web-auth.flags';
import { returnUrlFor } from '../web-auth/next-route';

/** Oturumsuz ziyaretçinin gideceği giriş yolu: QR açıkken /admin için /auth/admin (adminGuard ile aynı hedef, yarış yok). */
export function loginPathFor(url: string, qrEnabled: boolean = QR_LOGIN_ENABLED): string {
    return qrEnabled && /^\/admin(?:[/?#]|$)/.test(url) ? '/auth/admin' : '/auth/login';
}

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const accessToken = this.authService.getAccessToken();

        // If token is not present or expired, try to refresh it
        if (!accessToken || this.authService.isTokenExpired(accessToken)) {
            return this.authService
                .handleTokenRefresh(() => of(true))
                .pipe(
                    map(() => true),
                    catchError((error) => {
                        if (isSessionLoginRequired(error)) {
                            // Dönüş adresi (yol+sorgu, ör. iyzico ?checkout&result) girişten sonra korunur.
                            const q = returnUrlFor(state?.url);
                            if (q) this.router.navigate([loginPathFor(state.url)], { queryParams: q });
                            else this.router.navigate([loginPathFor(state?.url ?? '')]);
                        }
                        return of(false);
                    })
                );
        }

        // If the token is valid, allow access
        return of(true);
    }
}
